import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: "relative",
        bottom: 0,
        width: "100%",
        mt: "auto",
        py: 2,
        textAlign: "center",
        borderTop: "1px solid #ddd",
        backgroundColor: "#f8f9fa",
        fontFamily: "Heebo",
      }}
      dir="rtl"
    >
      <Typography variant="caption" color="textSecondary">
        © {new Date().getFullYear()} מדיטסט · כל הזכויות שמורות
      </Typography>
    </Box>
  );
};

export default Footer;
